import React, { Component } from 'react';
import Spinner from '../../../../../components/Spinner/index';
import { Tabs, Tab } from 'react-bootstrap';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Select from '../../../../../components/Select/index';

import {
    fetchStates,
    fetchState,
    updateStateSelected
} from '../../../../../services/redux/employee/state/actions';

class ClientInformation extends Component {
    componentDidMount() {
        let { fetchStates } = this.props;
        fetchStates();
    }
    componentWillUnmount() {
        let { updateStateSelected } = this.props;
        updateStateSelected({});
    }

    handleStateChange = (name, value) => {
        let { updateStateSelected, fetchState, history } = this.props;

        if (value) {
            updateStateSelected(value);
            fetchState(value.stateId).then(response => {
                if (response) {
                    history.push('/edit-state');
                }
            });
        }
    };

    render() {
        let { stateData } = this.props;
        return (
            <div role="tabpanel" className="panel col-md-6 mb" style={{padding: 0}}>
                <Tabs defaultActiveKey={1} id="tabID">
                    <Tab eventKey={1} title="Search State">
                        <div className="row">
                            <div>
                                <Select
                                    placeholder="Choose a State"
                                    labelKey="name"
                                    valueKey="code"
                                    selectedValue={
                                        Object.keys(stateData.selectedItemData)
                                            .length &&
                                        stateData.selectedItemData
                                    }
                                    onChange={this.handleStateChange}
                                    options={stateData.states}
                                />
                            </div>
                        </div>
                    </Tab>
                </Tabs>
                {stateData.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    stateData: state.employee.state
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchStates,
            fetchState,
            updateStateSelected
        },
        dispatch
    );
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ClientInformation));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ManageStates/screens/index.js